(function () {
  'use strict';

  /* ---------- Color swatch image swap ---------- */
  function initSwatches(root) {
    (root || document).querySelectorAll('[data-product-card]').forEach(function (card) {
      var mainImg = card.querySelector('.pcard__image');
      var swatches = card.querySelectorAll('[data-swatch]');
      if (!mainImg || !swatches.length) return;
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          var url = sw.getAttribute('data-swap-image');
          if (url) {
            mainImg.src = url;
            mainImg.removeAttribute('srcset');
          }
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Compare feature ---------- */
  var STORE_KEY = 'groovz:compare';
  var MAX = 4;

  function load() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; }
  }
  function save(list) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function initCompare() {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return;
    var itemsEl = bar.querySelector('[data-compare-items]');
    var countEl = bar.querySelector('[data-compare-count]');
    var modal = document.querySelector('[data-compare-modal]');
    var gridEl = modal ? modal.querySelector('[data-compare-grid]') : null;
    var toggles = document.querySelectorAll('[data-compare-toggle]');

    var list = load();

    function findToggle(handle) {
      return Array.prototype.find.call(toggles, function (t) { return t.getAttribute('data-handle') === handle; });
    }

    function syncChecks() {
      toggles.forEach(function (t) {
        t.checked = list.some(function (i) { return i.handle === t.getAttribute('data-handle'); });
      });
    }

    function render() {
      if (countEl) countEl.textContent = String(list.length);
      bar.hidden = list.length === 0;
      if (itemsEl) {
        itemsEl.innerHTML = list.map(function (i) {
          return '<div class="compare-bar__thumb"><img src="' + i.image + '" alt="' + i.title + '">' +
            '<button type="button" aria-label="Remove" data-remove="' + i.handle + '">×</button></div>';
        }).join('');
        itemsEl.querySelectorAll('[data-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () { remove(btn.getAttribute('data-remove')); });
        });
      }
      save(list);
    }

    function add(data) {
      if (list.length >= MAX) {
        var t = findToggle(data.handle);
        if (t) t.checked = false;
        alert('You can compare up to ' + MAX + ' products at a time.');
        return;
      }
      if (!list.some(function (i) { return i.handle === data.handle; })) {
        list.push(data);
        render();
      }
    }
    function remove(handle) {
      list = list.filter(function (i) { return i.handle !== handle; });
      var t = findToggle(handle);
      if (t) t.checked = false;
      render();
      if (list.length === 0) closeModal();
    }

    toggles.forEach(function (t) {
      t.addEventListener('change', function () {
        if (t.checked) {
          add({
            handle: t.getAttribute('data-handle'),
            title: t.getAttribute('data-title'),
            url: t.getAttribute('data-url'),
            image: t.getAttribute('data-image'),
            price: t.getAttribute('data-price')
          });
        } else {
          remove(t.getAttribute('data-handle'));
        }
      });
    });

    var clearBtn = bar.querySelector('[data-compare-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function () { list = []; syncChecks(); render(); closeModal(); });

    // Spec data: { handle: [value, value, ...] } aligned to data-spec-labels
    var specMap = {};
    var specLabels = [];
    (function () {
      var specEl = document.querySelector('[data-compare-specs]');
      if (specEl) { try { specMap = JSON.parse(specEl.textContent); } catch (e) {} }
      if (gridEl && gridEl.getAttribute('data-spec-labels')) {
        specLabels = gridEl.getAttribute('data-spec-labels').split('|').map(function (l) { return l.trim(); }).filter(Boolean);
      }
    })();

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function openModal() {
      if (!modal || !gridEl) return;
      var haveSpecs = specLabels.length && list.some(function (i) { return specMap[i.handle]; });

      var html = '<table class="compare-table"><thead><tr><th class="compare-table__label"></th>' +
        list.map(function (i) {
          return '<th class="compare-table__product">' +
            '<img class="compare-item__img" src="' + esc(i.image) + '" alt="' + esc(i.title) + '">' +
            '<p class="compare-item__title">' + esc(i.title) + '</p>' +
            '<p class="compare-item__price">' + esc(i.price) + '</p>' +
            '<a class="compare-item__link" href="' + esc(i.url) + '">View product</a>' +
            '</th>';
        }).join('') + '</tr></thead><tbody>';

      if (haveSpecs) {
        specLabels.forEach(function (label, idx) {
          var values = list.map(function (i) {
            var row = specMap[i.handle] || [];
            return row[idx] && row[idx] !== '' ? row[idx] : '—';
          });
          // skip rows where nothing is known for any selected product
          if (values.every(function (v) { return v === '—'; })) return;
          html += '<tr><th class="compare-table__label" scope="row">' + esc(label) + '</th>' +
            values.map(function (v) { return '<td class="compare-table__value">' + esc(v) + '</td>'; }).join('') + '</tr>';
        });
      }
      html += '</tbody></table>';
      gridEl.innerHTML = html;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    var openBtn = bar.querySelector('[data-compare-open]');
    if (openBtn) openBtn.addEventListener('click', openModal);
    if (modal) modal.querySelectorAll('[data-compare-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    syncChecks();
    render();
  }

  /* ---------- Swatch overflow pagination dots ---------- */
  function initSwatchDots(root) {
    (root || document).querySelectorAll('[data-product-card]').forEach(function (card) {
      var row = card.querySelector('.pcard__swatches');
      var dotsWrap = card.querySelector('[data-swatch-dots]');
      if (!row || !dotsWrap || dotsWrap.dataset.ready) return;
      dotsWrap.dataset.ready = '1';

      function build() {
        var pages = Math.ceil(row.scrollWidth / row.clientWidth);
        if (pages <= 1) { dotsWrap.hidden = true; dotsWrap.innerHTML = ''; return; }
        dotsWrap.hidden = false;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          (function (page) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pcard__swatch-dot' + (page === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Swatches page ' + (page + 1));
            dot.addEventListener('click', function () {
              row.scrollTo({ left: page * row.clientWidth, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
          })(i);
        }
      }

      row.addEventListener('scroll', function () {
        var dots = dotsWrap.querySelectorAll('.pcard__swatch-dot');
        if (!dots.length) return;
        var page = Math.round(row.scrollLeft / row.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === page); });
      }, { passive: true });

      window.addEventListener('resize', build);
      build();
    });
  }

  function init() { initSwatches(); initSwatchDots(); initCompare(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { initSwatches(e.target); initSwatchDots(e.target); initCompare(); });
})();
